/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContactResponseDto } from '../../models/sales-contact-response-dto';

export interface ContactsControllerRemoveReferent$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the contact.
 */
  id: string;

/**
 * The email of the referent to remove.
 */
  referentEmail: string;
}

export function contactsControllerRemoveReferent(http: HttpClient, rootUrl: string, params: ContactsControllerRemoveReferent$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contactsControllerRemoveReferent.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.path('referentEmail', params.referentEmail, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContactResponseDto>;
    })
  );
}

contactsControllerRemoveReferent.PATH = '/o2-sales/contacts/{tenant}/{id}/referents/{referentEmail}';
